import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
`;


export const Container = styled.div`
  width: 420px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  border-bottom: 1px solid #eee;

  button {
    background: none;
    border: 0;
    cursor: pointer;
  }
`;

export const Content = styled.div`
  padding: 16px;
`;
